<div class="w-full h-1 bg-primary-500"></div>

<div class="w-full py-8 px-12 relative" *vsLet="config$ | async as config">
  <!-- Header -->
  <div class="flex gap-4">
    <div class="flex flex-col flex-1 justify-center">
      <h1 class="text-lg font-bold text-gray-900">{{ warranty.details.title }}</h1>
      <h2 class="text-gray-700 truncate" *ngIf="warranty.details.tagline">{{ warranty.details.tagline }}</h2>
      <p class="text-sm text-gray-700">{{ warranty.contractNumber }}</p>
    </div>

    <img *ngIf="config?.logo as logo" class="max-w-[200px] h-20 object-contain object-right" [src]="logo" />
  </div>

  <div class="mt-12 grid grid-cols-1 gap-8" [class.grid-cols-[2fr_1fr]]="!!warranty.distributor">
    <!-- Customer -->
    <div>
      <p class="mb-1 font-semibold border-b border-gray-900">Registered Customer</p>

      <div class="grid grid-cols-[1fr_auto] gap-4">
        <div>
          <p>{{ warranty.customer.name }}</p>
          <p>{{ warranty.customer.email }}</p>
          <p>{{ warranty.customer.phone }}</p>
        </div>

        <div>
          <p>{{ warranty.customer.address.line1 }}</p>
          <p>
            {{ warranty.customer.address.city }}, {{ warranty.customer.address.state }},
            {{ warranty.customer.address.zip }}
          </p>
        </div>
      </div>
    </div>

    <!-- Distributor -->
    <div *ngIf="warranty.distributor.name">
      <p class="mb-1 font-semibold border-b border-gray-900">Distributor</p>
      <p class="truncate">{{ warranty.distributor.name }}</p>
      <p class="truncate">{{ warranty.distributor.email }}</p>
      <p class="truncate">{{ warranty.distributor.phone }}</p>
    </div>
  </div>

  <!-- Asset -->
  <div class="mt-8">
    <p class="mb-1 font-semibold border-b border-gray-900">Covered Asset</p>

    <div class="flex gap-x-8 gap-y-4">
      <ng-container *ngFor="let property of warranty.asset.properties">
        <div>
          <p class="font-semibold text-sm text-gray-900 truncate">{{ property.label }}</p>
          <p class="truncate" [innerHTML]="property.value | safe: 'html'"></p>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="mt-8">
    <p class="mb-1 font-semibold border-b border-gray-900">Coverage & Add-ons</p>
    <p class="truncate">Effective {{ warranty.termStartDate | date: 'longDate' }}</p>
    <p class="truncate">
      <span class="font-semibold">{{ warranty.details.title }} -</span> {{ warranty.details.plan }}
    </p>

    <ng-container *ngFor="let cov of warranty.coverages">
      <p class="truncate" *ngIf="cov.requirement !== 'NOT_APPLICABLE' && cov.requirement !== 'BASE'">
        <span class="font-semibold">Add-on -</span> {{ cov.title }}
      </p>
    </ng-container>
  </div>
</div>

<div class="absolute bottom-8 w-full">
  <p class="text-center text-gray-700">{{ warranty.contractNumber }}</p>
  <p class="text-center text-gray-700 text-sm">{{ today | date: 'longDate' }}</p>
</div>
